'use strict';

/**
 *
 * @name: curatedByMembers
 *
 */

import DirectiveTemplate from './nn-curated-by-members.directive.html';
import './nn-curated-by-members.directive.scss';

function CuratedByMembersDirective(Playlist, transObject, $translate) {

  'ngInject';

  return {
    replace: true,
    restrict: 'A',
    transclude: true,
    scope: {
      content: '&',
      loaded: '='
    },
    template: DirectiveTemplate,
    link: function(scope, element) {

      scope.item = scope.content();
      scope.firstTime = true;
      scope.swiperOptions = {
        spaceBetween: 30,
        on: {
          reachEnd: () => {
            scope.getPlaylists()
          }
        }
      }

      function terminate() {

        scope.$destroy();
        element.find('*').remove();
        element.remove();
      }

      if (!scope.item.jsonData.sources ||
        !scope.item.jsonData.sources[0] ||
        !scope.item.jsonData.sources[0].order ||
        !scope.item.jsonData.sources[0].order[0]) {

        return terminate();
      }

      scope.item.title = scope.item.title || $translate.instant('CURATED_BY_NOWNESS_MEMBERS');

      function runPlaylists(playlists) {

        playlists
          .forEach(function(item) {

            if (scope.item.jsonData.sources.length > 1) {

              scope.item.jsonData.sources.some(function(source, index) {

                if (item.id === source.playlistId) {

                  item.index = index;
                  return true;
                }

                return false;
              });
            }

            transObject.translate(item);
            transObject.getDuration(item);
            transObject.trueSlug(item);
            transObject.trueSlug(item.user);
          });
      }

      if (scope.item.jsonData.sources[0].playlistId) {

        scope.cache = scope.item.playlists;
        runPlaylists(scope.cache);
        scope.loaded = true;
      } else {

        scope.cache = [];

        var order;

        if (scope.item.jsonData.sources[0].order && scope.item.jsonData.sources[0].order[0]) {

          order = scope.item.jsonData.sources[0].order[0];
        } else {

          order = null;
        }

        var params = {
          order: order,
          limit: 8,
          page: 1,
          type: 'memberPlaylist'
        };

        scope.getPlaylists = function() {

          if (!scope.disableIS && (!scope.totalPages || params.page <= scope.totalPages)) {

            scope.firstTime = false;
            scope.disableIS = true;
            params.hasVideos = true;

            Playlist
              .get(params).$promise
              .then(function(res) {

                if (params.page === 1 && res.items.length < 6) {
                  terminate();
                }

                scope.totalPages = res.meta.totalPages;
                params.page++;
                runPlaylists(res.items);

                res.items.forEach(function(item) {

                  scope.cache.push(item);
                });
                scope.loaded = true;
                scope.disableIS = false;

                scope.baseSwiper.setUpdate()
              }, function() {

                scope.disableIS = false;
              });
          }
        };

        scope.getPlaylists();
      }
    }
  };
}

export default CuratedByMembersDirective;



// WEBPACK FOOTER //
// ./app/pages/playlist/nn-curated-by-members/nn-curated-by-members.directive.js